import {FAILURE, PENDING, SUCCESS} from '../../constants'
import {postConfiguration as postConfigurationAPI} from '../../../services/reservations'
import validate from './validate'

export async function postConfiguration(dispatch, data) {
  try {
    dispatch({type: PENDING})
    const errors = validate(data)
    if (!errors) {
      let response = await postConfigurationAPI(data)
      dispatch({type: SUCCESS, payload: response})
      return response
    } else {
      dispatch({type: FAILURE, payload: {errors: errors}})
      return Promise.reject({errors: errors})
    }
  } catch (e) {
    dispatch({type: FAILURE, payload: e})
    return Promise.reject(e)
  }
}
